import React, { Component } from "react";
import PropTypes from "prop-types";
import SidebarLink from "./SidebarLink";
import { signout } from "../../../redux/middlewares/authMIddleware";
import { connect } from "react-redux";
// import SidebarCategory from "./SidebarCategory";

class SidebarContent extends Component {
  static propTypes = {
    changeToDark: PropTypes.func.isRequired,
    changeToLight: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired
  };

  hideSidebar = () => {
    const { onClick } = this.props;
    onClick();
  };
  logOutHandler = () => {
    this.hideSidebar();
    this.props.signout();
  };
  render() {
    // const { changeToDark, changeToLight } = this.props;
    return (
      <div className="sidebar__content">
        {this.props.user.admin === true ? (
          // Admin Links
          <>
            <ul className="sidebar__block">
              <SidebarLink
                title="Post Job"
                icon="file-add"
                route="/jobs/post-job"
                onClick={this.hideSidebar}
              />
              <>
                <SidebarLink
                  title="Jobs"
                  icon="briefcase"
                  route="/jobs/view-jobs"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="Paid Jobs"
                  icon="briefcase"
                  route="/jobs/view-paid-jobs"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="Companies"
                  icon="apartment"
                  route="/companies/view-companies"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="News Letter"
                  icon="envelope"
                  route="/email"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="Settings"
                  icon="cog"
                  route="/settings"
                  onClick={this.hideSidebar}
                />
              </>
            </ul>
            <ul className="sidebar__block">
              <SidebarLink
                title="Resources"
                icon="book"
                route="/resources"
                onClick={this.hideSidebar}
              />
              <SidebarLink
                title="Subscriptions"
                icon="envelope"
                route="/subscriptions"
                onClick={this.hideSidebar}
              />
            </ul>
            <ul className="sidebar__block">
              <SidebarLink
                title="Log Out"
                icon="exit"
                route="#"
                onClick={() => this.logOutHandler()}
              />
            </ul>
          </>
        ) : (
          // Other Users Links
          <>
            <ul className="sidebar__block">
              <SidebarLink
                title="Post Job"
                icon="file-add"
                route="/jobs/post-job"
                onClick={this.hideSidebar}
              />
              <SidebarLink
                title="Jobs"
                icon="briefcase"
                route="/jobs/view-jobs"
                onClick={this.hideSidebar}
              />
              {/* <SidebarLink
                title="Paid Jobs"
                icon="briefcase"
                route="/jobs/view-paid-jobs"
                onClick={this.hideSidebar}
              /> */}
              <SidebarLink
                title="Companies"
                icon="apartment"
                route="/companies/view-companies"
                onClick={this.hideSidebar}
              />
            </ul>
            <ul className="sidebar__block">
              <SidebarLink
                title="Log Out"
                icon="exit"
                route="#"
                onClick={() => this.logOutHandler()}
              />
            </ul>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.authReducer.user
});

export default connect(mapStateToProps, { signout })(SidebarContent);
